export default __webpack_public_path__ + "static/media/williamVanderheydenPic@4x.29bb3968.png";